import type { CSSProperties } from 'react';

/**
 * LED status dot — 6 px signature element of the DS.
 * Never pulses except when kind === 'run' (handled by .badge.run .dot CSS rule
 * when used inside a Badge ; here the dot is static by default).
 */
export type LEDKind = 'ok' | 'run' | 'warn' | 'fail' | 'idle' | 'info';

const COLOR_MAP: Record<LEDKind, string> = {
  ok:   'var(--success)',
  run:  'var(--info)',
  warn: 'var(--warning)',
  fail: 'var(--danger)',
  info: 'var(--info)',
  idle: 'var(--text-disabled)',
};

export interface LEDProps {
  kind?: LEDKind;
  size?: number;
  pulse?: boolean;
  style?: CSSProperties;
  'aria-label'?: string;
}

export function LED({
  kind = 'ok',
  size = 6,
  pulse = false,
  style,
  ...rest
}: LEDProps) {
  return (
    <span
      role={rest['aria-label'] ? 'img' : undefined}
      aria-hidden={rest['aria-label'] ? undefined : true}
      aria-label={rest['aria-label']}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        background: COLOR_MAP[kind],
        flexShrink: 0,
        animation: pulse ? 'pulse 1.4s var(--ease-in-out) infinite' : undefined,
        ...style,
      }}
    />
  );
}
